import { SavedSearch } from '@saved-search/models/saved-search';

export class SavedSearchState {
    public readonly savedSearches: SavedSearch[] = [];
    public readonly activeSavedSearchId?: number = null;
}